import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "./lib/apolloClient";
import { Toaster } from "./components/ui/Toaster";
import { TooltipProvider } from "./components/ui/Tooltip";
import Home from "./pages/Home";
import Vendors from "./pages/Vendors";
import Investors from "./pages/Investors";
import TermsAndConditions from "./pages/TermsAndConditions";
import VendorTerms from "./pages/VendorTerms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CancellationPolicy from "./pages/CancellationPolicy";
import DeliveryPartnerTerms from "./pages/DeliveryPartnerTerms";
import NotFound from "./pages/NotFound";
import ContactUs from "./pages/ContactUs";
import DeleteAccount from "./pages/DeleteAccount";
import ScrollToTop from "./components/common/ScrollToTop";

function Router() {
  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/vendors" component={Vendors} />
        <Route path="/investors" component={Investors} />
        <Route path="/terms" component={TermsAndConditions} />
        <Route path="/vendor-terms" component={VendorTerms} />
        <Route path="/privacy" component={PrivacyPolicy} />
        <Route path="/cancellation-policy" component={CancellationPolicy} />
        <Route path="/delivery-partner-terms" component={DeliveryPartnerTerms} />
        <Route path="/contact" component={ContactUs} />
        <Route path="/delete-account" component={DeleteAccount} />
        <Route component={NotFound} />
      </Switch>
    </>
  );
}

function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </QueryClientProvider>
    </ApolloProvider>
  );
}

export default App;
